import { Component, OnInit, ViewChild } from '@angular/core';
import { trigger, state, transition, style, animate } from '@angular/animations';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog } from '@angular/material';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { EventRoadService } from '../../services/eventRoad.service';
import { Roadbook } from '../../models/roadbook.model';
import { FileFirebaseUpload } from '../../models/fileFirebaseUpload.model';
import { FileUpload } from '../../models/fileUpload.model';
import { FileService } from '../../services/file.service';
import { PrestashopService } from '../../services/prestashop.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { RoadbookOption } from '../../models/roadbookOption.model';
import { ShowerrordialogComponent } from '../showerrordialog/showerrordialog.component';
import { ExcelService } from '../../services/excel.service';
import { FolderFormComponent } from '../folder-form/folder-form.component';
import { FolderService } from '../../services/folder.service';
import { FolderGestorComponent } from '../folder-gestor/folder-gestor.component';
import { QrDialogComponent } from '../qr-dialog/qr-dialog.component';

@Component({
  selector: 'app-roadbooks-page',
  templateUrl: './roadbooks-page.component.html',
  styleUrls: ['./roadbooks-page.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class RoadbooksPageComponent implements OnInit {

  panelOpenState = false;
  neweventroadform: FormGroup;
  expandedElement: Roadbook | null;
  displayedColumns: string[] = ['star', 'name', 'code', 'visible', 'actions' ];
  dataSource: MatTableDataSource<Roadbook>;
  filteredRoadbooks: Observable<any>;
  roadbooksWeb: RoadbookOption[];
  roadbookFile: FileFirebaseUpload[] = [];
  guideFile: FileFirebaseUpload[] = [];
  gpxFile: FileFirebaseUpload[] = [];
  eventRoads: Roadbook[] = [];
  tEventRoads: Roadbook[] = [];
  editingEventRoad: Roadbook = null;
  emails: string[] = [];
  emails_admin: string[] = [];
  emails_qr: string[] = [];
  currentPath = '';
  currentFolder = null;
  currentFolders = [];
  folders = [];
  pathFolders = [];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private formBuilder: FormBuilder,
    private eventRoadProvider: EventRoadService,
    private _fs: FileService,
    private _pss: PrestashopService,
    public dialog: MatDialog,
    private excelService: ExcelService,
    private folderService: FolderService) {
    this.neweventroadform = this.formBuilder.group({
      name: [null, Validators.required],
      code: [null, null],
      roadbook_type: [null, Validators.required],
      activation_code: [null, null],
      roadbook: [null, null],
      visible: [null, null],
      path: [null, null],
      interes: [null, null],
      distancia: [null, null],
      duracio: [null, null],
      estacionalitat: [null, null],
      geolocalitzacio: [null, null],
      geolocalitzacio2: [null, null],
      geolocalitzacio3: [null, null],
      geolocalitzacio4: [null, null],
      geolocalitzacio5: [null, null],
      pages: [null, null],
      destinated_users: [1, null],
      emails: [null, Validators.email],
      emails_admin: [null, Validators.email],
      emailsqr: [null, Validators.email],
      qr_link: [null, null]
    });
    this.neweventroadform.controls['destinated_users'].valueChanges.subscribe(val => {
      if (val === 2) {
        this.neweventroadform.controls['visible'].setValue(false);
      }
    });
    this.folderService.getAll().subscribe(folders => {
      this.folders = folders.sort((a, b) => (b.n > a.n ? -1 : 1));
      this.updateFolderTree();
    });
    debugger
    try {
        this.filteredRoadbooks = this._pss.getVirtualProducts().pipe(map((value, idx) => {
          return value.map(vi => new RoadbookOption(vi.id, vi.name[0].value) );
        }));
    } catch (error) {
      debugger
      this.filteredRoadbooks = of([]);
    }
  }

  ngOnInit() {
    this.filteredRoadbooks.subscribe({
      next: value => {
        this.roadbooksWeb = value;
        this.eventRoadProvider.getAll().subscribe({
          next: data => {
            this.eventRoads = data;
            this.tEventRoads = this.eventRoads.slice(0);
            this.updateFolderTree();
          },
          error: err => {
            // Si falla la càrrega dels eventRoads, buidem però mantenim el mateix comportament
            this.eventRoads = [];
            this.tEventRoads = [];
            this.updateFolderTree();
          }
        });
      },
      error: err => {
        // Si falla la càrrega dels roadbooks, buidem i intentem carregar igualment eventRoads
        this.roadbooksWeb = [];
        this.eventRoadProvider.getAll().subscribe({
          next: data => {
            this.eventRoads = data;
            this.tEventRoads = this.eventRoads.slice(0);
            this.updateFolderTree();
          },
          error: err2 => {
            this.eventRoads = [];
            this.tEventRoads = [];
            this.updateFolderTree();
          }
        });
      }
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  saveEventRoad() {
    const errors = this.ValidateForm();
    if (errors.length === 0) {
      const eventRoad = this.getEventRoadFromForm();
      console.log(eventRoad);
      if (this.editingEventRoad) {
        eventRoad.id = this.editingEventRoad.id;
        this.eventRoadProvider.edit(eventRoad);
        this.editingEventRoad = null;
      } else {
        const result = this.eventRoadProvider.create(eventRoad);
      }
      this.roadbookFile.forEach(f => {
        const fi = new FileUpload(f.id, f.name, f.url, f.type, f.path, f.realName);
        this._fs.create(fi);
      });
      this.guideFile.forEach(f => {
        const fi = new FileUpload(f.id, f.name, f.url, f.type, f.path, f.realName);
        this._fs.create(fi);
      });
      this.gpxFile.forEach(f => {
        const fi = new FileUpload(f.id, f.name, f.url, f.type, f.path, f.realName);
        this._fs.create(fi);
      });
      this.reset();
    } else {
      const dialogRef = this.dialog.open(ShowerrordialogComponent, { data: errors });
    }
  }
  editElemet(element) {
    this.editingEventRoad = element;
    this.neweventroadform.controls['name'].setValue(this.editingEventRoad.name);
    this.neweventroadform.controls['code'].setValue(this.editingEventRoad.code);
    this.neweventroadform.controls['activation_code'].setValue(this.editingEventRoad.activation_code);
    this.neweventroadform.controls['visible'].setValue(this.editingEventRoad.visible);
    this.neweventroadform.controls['roadbook_type'].setValue(this.editingEventRoad.roadbook_type);
    this.neweventroadform.controls['roadbook'].setValue(this.editingEventRoad.roadbook);
    this.neweventroadform.controls['interes'].setValue(this.editingEventRoad.interes);
    this.neweventroadform.controls['distancia'].setValue(this.editingEventRoad.distancia);
    this.neweventroadform.controls['duracio'].setValue(this.editingEventRoad.duracio);
    this.neweventroadform.controls['estacionalitat'].setValue(this.editingEventRoad.estacionalitat);
    this.neweventroadform.controls['geolocalitzacio'].setValue(this.editingEventRoad.geolocalitzacio);
    this.neweventroadform.controls['geolocalitzacio2'].setValue(this.editingEventRoad.geolocalitzacio2);
    this.neweventroadform.controls['geolocalitzacio3'].setValue(this.editingEventRoad.geolocalitzacio3);
    this.neweventroadform.controls['geolocalitzacio4'].setValue(this.editingEventRoad.geolocalitzacio4);
    this.neweventroadform.controls['geolocalitzacio5'].setValue(this.editingEventRoad.geolocalitzacio5);
    this.neweventroadform.controls['pages'].setValue(this.editingEventRoad.pages);
    this.neweventroadform.controls['path'].setValue(this.editingEventRoad.path ? this.editingEventRoad.path : null);
    this.neweventroadform.controls['qr_link'].setValue(this.editingEventRoad.qr_link);
    if (this.editingEventRoad.destinated_users) {
      this.neweventroadform.controls['destinated_users'].setValue(this.editingEventRoad.destinated_users);
    } else {
      this.neweventroadform.controls['destinated_users'].setValue(1);
    }
    this.neweventroadform.controls['emails'].setValue('');
    if (this.editingEventRoad.emails) {
      this.emails = this.editingEventRoad.emails.slice(0);
    }
    this.neweventroadform.controls['emails_admin'].setValue('');
    if (this.editingEventRoad.emails_admin) {
      this.emails_admin = this.editingEventRoad.emails_admin.slice(0);
    }
    this.neweventroadform.controls['emailsqr'].setValue('');
    if (this.editingEventRoad.emails_qr) {
        this.emails_qr = this.editingEventRoad.emails_qr.slice(0);
      }
    this.roadbookFile = [];
    this.guideFile = [];
    this.gpxFile = [];
    this._fs.getFile(this.editingEventRoad.filename).subscribe((fi: FileUpload) => {
      if (fi) {
        const fui = new FileFirebaseUpload();
        fui.id = fi.id;
        fui.name = fi.name;
        fui.url = fi.url;
        fui.type = fi.type;
        fui.upload = true;
        fui.id = fi.id;
        fui.path = fi.path;
        fui.realName = fi.realName;
        fui.idTask = '';
        this.roadbookFile.push (fui);
      } else {
        // TODO: get from storage
      }
    });
    if (this.editingEventRoad.filenameGuide) {
      this._fs.getFile(this.editingEventRoad.filenameGuide).subscribe((fi: FileUpload) => {
        if (fi) {
          const fui = new FileFirebaseUpload();
          fui.id = fi.id;
          fui.name = fi.name;
          fui.url = fi.url;
          fui.type = fi.type;
          fui.upload = true;
          fui.id = fi.id;
          fui.path = fi.path;
          fui.realName = fi.realName;
          fui.idTask = '';
          this.guideFile.push (fui);
        } else {
          // TODO: get from storage
        }
      });
    }
    if (this.editingEventRoad.filenameGpx) {
      this._fs.getFile(this.editingEventRoad.filenameGpx).subscribe((fi: FileUpload) => {
        if (fi) {
          const fui = new FileFirebaseUpload();
          fui.id = fi.id;
          fui.name = fi.name;
          fui.url = fi.url;
          fui.type = fi.type;
          fui.upload = true;
          fui.id = fi.id;
          fui.path = fi.path;
          fui.realName = fi.realName;
          fui.idTask = '';
          this.gpxFile.push (fui);
        } else {
          // TODO: get from storage
        }
      });
    }
    this.panelOpenState = true;
    window.scroll(0, 0);
  }
  removeElemet(element) {
    this.eventRoadProvider.remove(element);
  }
  getEventRoadFromForm() {
    const filename = this.roadbookFile[0].id;
    const filenameGuide =  this.guideFile && this.guideFile.length > 0 ? this.guideFile[0].id : null;
    const filenameGpx =  this.gpxFile && this.gpxFile.length > 0 ? this.gpxFile[0].id : null;
    const roadbookUrl = (this.roadbookFile && this.roadbookFile.length > 0 && this.roadbookFile[0]) ? this.roadbookFile[0].url : '';
    return new Roadbook('',
      this.neweventroadform.controls['name'].value,
      this.neweventroadform.controls['code'].value,
      this.neweventroadform.controls['activation_code'].value,
      this.neweventroadform.controls['visible'].value,
      +(this.neweventroadform.controls['roadbook_type'].value),
      this.neweventroadform.controls['roadbook'].value,
      filename,
      this.neweventroadform.controls['interes'].value,
      this.neweventroadform.controls['distancia'].value,
      this.neweventroadform.controls['duracio'].value,
      this.neweventroadform.controls['estacionalitat'].value,
      this.neweventroadform.controls['geolocalitzacio'].value,
      +(this.neweventroadform.controls['pages'].value),
      +(this.neweventroadform.controls['destinated_users'].value),
      this.emails,
      this.emails_admin,
      filenameGuide,
      this.neweventroadform.controls['geolocalitzacio2'].value,
      this.neweventroadform.controls['geolocalitzacio3'].value,
      this.neweventroadform.controls['geolocalitzacio4'].value,
      this.neweventroadform.controls['geolocalitzacio5'].value,
      filenameGpx,
      this.neweventroadform.controls['path'].value,
      this.emails_qr,
      this.neweventroadform.controls['qr_link'].value ? this.neweventroadform.controls['qr_link'].value : roadbookUrl
      );
  }
  changeCheckBox(row, event) {
    this.eventRoadProvider.editVisible(row, event.checked);
  }
  getRoadbookName(id) {
    const o = this.roadbooksWeb.find(rw => rw.id === id);
    return (o) ? o.name : '';
  }
  getRoadbookType(id) {
    switch (id) {
      case 1:
        return 'Roadbook';
      case 2:
        return 'Roadbook Event';
      case 3:
        return 'Roadbook Promotional';
      case -1:
        return 'Roadbook Out of shop';
      case 4:
        return "Roadbook Event On Demand";
    }
    return 'Undefined type';
  }
  selectedRoadbook(event) {
    this.neweventroadform.controls['code'].setValue(event);
  }

  keyPressEmail(event) {
    if (event.key === 'Enter') {
      if (this.neweventroadform.controls['emails'].valid) {
        const val = this.neweventroadform.controls['emails'].value;
        if (val !== '') {
          this.emails.push(val);
          this.neweventroadform.controls['emails'].setValue('');
        }
      } else {
      }
      event.preventDefault();
    }
  }
  keyPressEmailQR(event) {
    if (event.key === 'Enter') {
      if (this.neweventroadform.controls['emailsqr'].valid) {
        const val = this.neweventroadform.controls['emailsqr'].value;
        if (val !== '') {
          this.emails_qr.push(val);
          this.neweventroadform.controls['emailsqr'].setValue('');
        }
      } else {
      }
      event.preventDefault();
    }
  }
  keyPressEmailAdministrator(event) {
    if (event.key === 'Enter') {
      if (this.neweventroadform.controls['emails_admin'].valid) {
        const val = this.neweventroadform.controls['emails_admin'].value;
        if (val !== '') {
          this.emails_admin.push(val);
          this.neweventroadform.controls['emails_admin'].setValue('');
        }
      } else {
      }
      event.preventDefault();
    }
  }
  removeEmail(email) {
    const index = this.emails.indexOf(email, 0);
    if (index > -1) {
      this.emails.splice(index, 1);
   }
  }
  removeEmailAdmin(email) {
    const index = this.emails_admin.indexOf(email, 0);
    if (index > -1) {
      this.emails_admin.splice(index, 1);
   }
  }
  removeEmailQR(email) {
    const index = this.emails_qr.indexOf(email, 0);
    if (index > -1) {
      this.emails_qr.splice(index, 1);
   }
  }
  ValidateForm() {
    const errors = [];
    let roadbookType = -1;
    const destinated_users = +this.neweventroadform.controls['destinated_users'].value;
    if (!this.neweventroadform.controls['name'].value) { errors.push('Cal indicar el nom del Roadbook'); }
    if (!this.neweventroadform.controls['roadbook_type'].value) {
      errors.push('Cal indicar el tipus de Roadbook');
    } else {
      roadbookType = +this.neweventroadform.controls['roadbook_type'].value;
    }
    if (this.roadbookFile.length === 0) { errors.push('Cal afegir el document PDF del Roadbook');
    } else if (this.roadbookFile[0].url === undefined || this.roadbookFile[0].url === null) { errors.push('Cal esperar que el fitxer estigui pujat al servidor'); }
    if (this.guideFile && this.guideFile.length > 0 && (this.guideFile[0].url === undefined || this.guideFile[0].url === null)) { errors.push('Cal esperar que el fitxer de la guia estigui pujat al servidor'); }
    if (this.gpxFile && this.gpxFile.length > 0 && (this.gpxFile[0].url === undefined || this.gpxFile[0].url === null)) { errors.push('Cal esperar que el fitxer GPX estigui pujat al servidor'); }
    if (roadbookType === 1 && !this.neweventroadform.controls['roadbook'].value) { errors.push('Cal indicar el Roadbook de la web de Vectornote'); }
    if (roadbookType === 2 && !this.neweventroadform.controls['code'].value) { errors.push('Cal indicar el codi del Roadbook'); }
    if (roadbookType === 3 && !this.neweventroadform.controls['activation_code'].value) { errors.push("Cal indicar el codi d'activació del Roadbook"); }
    if (destinated_users === 2 && this.emails.length === 0) { errors.push("Cal indicar un correu com a mínim si el roadbook va destinat a uns usuaris en concret"); }
    return errors;
  }
  reset() {
    this.roadbookFile = [];
    this.guideFile = [];
    this.gpxFile = [];
    this.neweventroadform.reset();
    this.emails = [];
    this.emails_admin = [];
    this.neweventroadform.controls['destinated_users'].setValue(1);
  }
  onFileChange(evt: any) {
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {

      const bstr: string = e.target.result;
      const data = <any[]>this.excelService.importFromFile(bstr);

      const emails = data.map(di => di[0]).filter(ei => this.emails.indexOf(ei) < 0);
      this.emails = this.emails.concat(emails);
    };
    reader.readAsBinaryString(target.files[0]);
  }
  onFileQRChange(evt: any) {
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {

      const bstr: string = e.target.result;
      const data = <any[]>this.excelService.importFromFile(bstr);

      const emails = data.map(di => di[0]).filter(ei => this.emails_qr.indexOf(ei) < 0);
      this.emails_qr = this.emails_qr.concat(emails);
    };
    reader.readAsBinaryString(target.files[0]);
  }
  addFolder() {
    const dialogRef = this.dialog.open(FolderFormComponent, {
      width: '250px',
      data: { folder: null }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.folderService.create({i: null, n: result.n, p: this.currentFolder});
        this.updateFolderTree();
      }
    });
  }
  updateFolderTree() {
    this.currentFolders = this.folders.filter(fi => fi.p === this.currentFolder);
    this.tEventRoads = this.eventRoads.filter(ei => (ei.path === this.currentFolder || (this.currentFolder === null && ei.path === undefined)));
    this.dataSource = new MatTableDataSource(this.tEventRoads);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.updatePath();
  }
  updatePath() {
    this.pathFolders = [];
    let fi = this.folders.find(fii => fii.i === this.currentFolder);
    while (fi) {
      this.pathFolders.push(fi);
      fi = this.folders.find(fii => fii.i === fi.p);
    }
    this.pathFolders = this.pathFolders.reverse();
  }
  getTotalRoadbooks(id) {
    return this.numRoadbooks(this.folders.find(fi => fi.i === id));
    // return this.eventRoads.filter(er => er.path === id);
  }
  removeFolder(folder) {
    this.folderService.remove(folder);
  }
  editCurrentFolder() {
    const cfi = this.folders.find(fi => fi.i === this.currentFolder );
    const dialogRef = this.dialog.open(FolderFormComponent, {
      width: '250px',
      data: { folder: cfi }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.folderService.edit(cfi);
        this.updateFolderTree();
      }
    });
  }
  selectFolder() {
    const dialogRef = this.dialog.open(FolderGestorComponent, {
      width: '400px',
      data: {
        folders: this.folders,
        selectedFolder: this.neweventroadform.controls['path'].value
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.neweventroadform.controls['path'].setValue(result);
      }
    });
  }
  getSelectedFolder() {
    const folder = this.folders.find(fi => fi.i === this.neweventroadform.controls['path'].value);
    if (folder) {
      return folder.n;
    }
    return 'Not specified';
  }
  numRoadbooks(folder) {
    return this.numRoadbooksRec(folder, 0);
  }
  numRoadbooksRec(folder, total) {
    let num = this.eventRoads.filter(ei => ei.path === folder.i).length;
    const child = this.folders.filter(fi => fi.p === folder.i);
    child.forEach(ci => {
      num += this.numRoadbooksRec(ci, 0);
    });
    total += num;
    return total;
  }
  showQR(roadbook: Roadbook) {
    const dialogRef = this.dialog.open(QrDialogComponent, {
        width: '400px',
        data: {
          roadbook: roadbook
        }
      });

      dialogRef.afterClosed().subscribe(result => {});
  }
  public applyFirebaseUrl() {
    const roadbookUrl = (this.roadbookFile && this.roadbookFile.length > 0 && this.roadbookFile[0]) ? this.roadbookFile[0].url : '';
    this.neweventroadform.controls['qr_link'].setValue(roadbookUrl);
  }
  public existsRoadbookUrl() {
    const roadbookUrl = (this.roadbookFile && this.roadbookFile.length > 0 && this.roadbookFile[0]) ? this.roadbookFile[0].url : '';
    return roadbookUrl !== '';
  }
}
class Contact {
  Email: string;
}
